import {ChamberEnum} from "../types/Chamber.enum";

export const chamberText = {
  [ChamberEnum.UPPER]: 'Upper',
  [ChamberEnum.LOWER]: 'Lower'
}
